<template>
  <footer>
    <div class="d-lg-none">
      <div class="mt-auto">
        <div class="px-5 py-6">
          <SupportInfo v-if="contactInfoEnabled"/>
          <PoweredByLendio v-if="poweredByLendioEnabled" />
        </div>
      </div>
    </div>
    <div v-if="privacyPolicyVisible" v-html="sanitizeHtml(privacyPolicyHtml)" class="px-xl-0 px-5 pt-4 mb-2 p-inline-xs"></div>
  </footer>
</template>
<script>
import SupportInfo from '~/components/SupportInfo.vue';
import PoweredByLendio from '~/components/PoweredByLendio.vue'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization';
import { mapState } from 'pinia'

export default {
    name: "EmbeddedFooter",
    setup() {
      const { sanitizeHtml } = useSanitize()
      return { sanitizeHtml }
    },
    components: {
      SupportInfo,
      PoweredByLendio
    },
    computed: {
      ...mapState(useAffiliateCustomizationStore, [
        'appStyles',
        'contactInfoEnabled',
        'appNavLogo',
        'poweredByLendioEnabled',
        'privacyPolicyHtml',
        'privacyPolicyVisible'
      ]),
    },
}
</script>

<style lang="scss">
@import 'assets/styles/affiliate-customizations/affiliate-customization-mixins';

footer {
  padding: 0 0 8px 0;
  @include media-breakpoint-up(xl) {
    padding: 0 64px 8px 64px;
  }
  p {
    font-size: 10px;
    color: $type-300;
  }

  a,
  a.link-primary {
    @include affiliateAppAnchorTag();
  }
}
</style>
